<template>
  <div id="app"> <!-- also need #app here for pre-rendered pages -->

    <dev-bar></dev-bar>
    <nav-bar></nav-bar>
    
    <div>
      <keep-alive include="DashboardPage">
        <router-view :key="$route.path"/>
      </keep-alive>
    </div>

    <foot-bar></foot-bar>
  </div>
</template>

<script>
import DevBar from '@/components/DevBar'
import NavBar from '@/components/NavBar'
import FootBar from '@/components/FootBar'

// Lives here rather than in index.html: vue-meta cannot override a static tag.
const DEFAULT_DESC = 'Print your blog as a beautiful hardcover book. WordPress, Blogger, Instagram, Tumblr, Squarespace and more. Free preview in minutes, printed and delivered.'

const OG_DESC = 'Print your blog as a beautiful, rich hardcover book. Automatically layout your book in just a few minutes. Import from wordpress, blogger, instagram and many others. Select posts to include, customize covers and then buy. Your book will be printed and delivered.'

//page-level schema refers back to this by @id, so the crawler ties the
//breadcrumbs, articles and product offers to one publisher
const ORGANISATION = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://pixxibook.com/#organization',
  name: 'PixxiBook',
  legalName: 'Bitlific Ltd',
  url: 'https://pixxibook.com',
  logo: 'https://pixxibook.com/static/logo-512.png',
  sameAs: [
    'https://twitter.com/PixxiBook',
    'https://facebook.com/pixxibook',
    'https://instagram.com/PixxiBook',
    'https://www.trustpilot.com/review/www.pixxibook.com',
  ],
}

export default {
  name: 'App',
  metaInfo() {
    // the prerenderer leaves a trailing slash; $route is absent in unit tests
    var route = this.$route
    var path = (route ? route.path.replace(/\/+$/, '') : '') || '/'
    var matched = route && route.matched && route.matched[route.matched.length-1]
    return {
    title: 'Easy Blog to Book',
    titleTemplate: 'PixxiBook | %s',
    //an unknown URL still answers 200, so it must not declare itself canonical
    link: matched && matched.path == '/*' ? []
      : [{ vmid: 'canonical', rel: 'canonical', href: 'https://pixxibook.com'+path }],
    meta: [
      { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      { vmid: 'twitter:site', name: 'twitter:site', content: '@PixxiBook' },
      { vmid: 'og:image', name: 'og:image', content: '/static/pixxi-layouts.jpg' },
      { vmid: 'og:title', name: 'og:title', content: 'PixxiBook: Easy Blog to Book' },
      { vmid: 'description', name: 'description', content: DEFAULT_DESC },
      { vmid: 'og:description', name: 'og:description', content: OG_DESC },
    ],
    //vue-meta escapes innerHTML unless the sanitiser is turned off
    script: [{ vmid: 'org', type: 'application/ld+json',
               innerHTML: JSON.stringify(ORGANISATION) }],
    __dangerouslyDisableSanitizers: ['innerHTML'],
  }},
  components: {
    DevBar,
    NavBar,
    FootBar,
  },
}
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/initial-variables.sass";
  $navbar-breakpoint: $tablet;

  @import "~bulma/sass/utilities/_all";

  // Set your colors
  $primary: #ff3860;
  $primary-invert: findColorInvert($primary);
  $danger: #ff0000;
  $danger-invert: findColorInvert($danger);
  
  // Setup $colors to use as bulma classes (e.g. 'is-twitter')  
  $colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "link": ($link, $link-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert)
  );

  // Links
  $link: $info;
  $link-invert: $info-invert;
  $link-focus-border: $info;

  $card-header-weight: 400;
  
  // Import Bulma and Buefy styles
  @import "~bulma";
  @import "~buefy/src/scss/buefy";

  .dev-only {
      background: $warning;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue